import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import cls from './material-icon.module.scss'

/**
 * Отображает символ из набора Material Icons (outlined-шрифт подключён глобально).
 * Поддерживает управление размером и цветом через пропсы/стили.
 */
export const MaterialIcon = React.forwardRef(function MaterialIcon(
  {
    name,
    size,
    color,
    className,
    style,
    ariaLabel,
    title,
    withContainer = false,
    containerSize,
    containerClassName,
    isSymbol = false,
    fill = 1,
    slim = true,
    rounded = false,
    ...props
  },
  ref,
) {
  if (!name) return null

  const normalizedSize = typeof size === 'number' ? `${size}px` : size

  const IconComponent = (
    <i
      ref={ref}
      className={classNames(cls.icon, className, {
        'material-symbols-outlined': isSymbol,
        'material-icons': !isSymbol,
      })}
      style={{
        fontSize: normalizedSize,
        color,
        fontVariationSettings: `'FILL' ${fill || rounded ? 1 : 0}${slim ? ', "wght" 300' : ''}`,
        ...style,
      }}
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
      title={title || ariaLabel || name}
      {...props}
    >
      {name}
    </i>
  )

  if (!withContainer && !rounded) return IconComponent

  const containerStyle = {
    width: containerSize ? `${containerSize}px` : undefined,
    height: containerSize ? `${containerSize}px` : undefined,
  }

  return (
    <div
      className={classNames(cls.container, containerClassName, { [cls.rounded]: rounded })}
      style={containerStyle}
    >
      {IconComponent}
    </div>
  )
})

MaterialIcon.propTypes = {
  /** Имя иконки из набора Material Icons */
  name: PropTypes.string.isRequired,
  /** Размер иконки (px или любое значение CSS) */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Цвет иконки */
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  /** Подпись для доступности; без неё иконка помечается как декоративная */
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  withContainer: PropTypes.bool,
  containerSize: PropTypes.number,
  containerClassName: PropTypes.string,
  isSymbol: PropTypes.bool,
}

export default MaterialIcon
